import { useSetAtom } from 'jotai';
import { activeFiltersAtom } from '@/atoms/filters';
import { versionAtom } from '@/atoms/version';
import { companyIdAtom, projectIdAtom } from '@/atoms/workspace';
import { useCommentableTextAtoms } from '@/comments';
import { FILTERS_DEFAULT_STATE } from '@/constants';
import { useChangeUser, useSetPref } from '@/preferences';

interface IWorkspace {
    projectID?: number;
    companyID?: number;
}

export const useWorkspace = () => {
    const { clear } = useCommentableTextAtoms();
    const changeUser = useChangeUser();
    const setEditorEpisodeId = useSetPref('editor_episode_id');
    const setEditorScene = useSetPref('editor_scene');
    const setVersion = useSetAtom(versionAtom);
    const setCompanyId = useSetAtom(companyIdAtom);
    const setProjectId = useSetAtom(projectIdAtom);
    const setActiveFilters = useSetAtom(activeFiltersAtom);

    const switchWorkspace = ({ companyID, projectID }: IWorkspace) => {
        setVersion('');
        setEditorEpisodeId(null);
        clear();
        setEditorScene({ id: null, act: 0 });
        changeUser({ episode_id: null });

        if (projectID) {
            setActiveFilters(FILTERS_DEFAULT_STATE);
            setProjectId(projectID);
        }

        if (companyID) {
            setActiveFilters(FILTERS_DEFAULT_STATE);
            setCompanyId(companyID);

            if (!projectID) {
                setProjectId(null);
            }
        }
    };

    return switchWorkspace;
};
